export default {"src":"/_next/static/media/trending-icon.0abbe53f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};